<article>
  <header>
    <strong>TMA Diário</strong>
    <div class="sub-title">_</div>
  </header>
  <main>
    <app-bar-chart [loading]="isLoading" [error]="error"></app-bar-chart>
  </main>
</article>
